export default __webpack_public_path__ + "static/media/Heroku.a9fb20d7.png";